import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mb-2 mx-0",
    "data-cy": "questionnaire-response-details-header"
};
const _hoisted_2 = { class: "row mt-3 mx-0" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "row mt-1 mx-0" };
const _hoisted_5 = { class: "col-auto col-lg-6 ps-0" };
const _hoisted_6 = {
    key: 0,
    class: "table-responsive"
};
const _hoisted_7 = { class: "table table-bordered table-striped table-sm" };
const _hoisted_8 = { "data-cy": "questionnaire-response-details-id" };
const _hoisted_9 = { class: "table-light" };
const _hoisted_10 = { "data-cy": "questionnaire-response-details-version" };
const _hoisted_11 = { class: "table-light" };
const _hoisted_12 = { class: "table-light" };
const _hoisted_13 = { "data-cy": "questionnaire-response-details-questionnaire" };
const _hoisted_14 = { class: "table-light" };
const _hoisted_15 = { class: "table-light" };
const _hoisted_16 = { class: "table-light" };
const _hoisted_17 = { class: "table-light" };
const _hoisted_18 = { class: "row mx-0 mt-3" };
const _hoisted_19 = { class: "row mx-0 mt-1" };
const _hoisted_20 = { class: "col-auto col-lg-6" };
const _hoisted_21 = {
    key: 1,
    class: "row mx-0 mt-3"
};
const _hoisted_22 = {
    key: 2,
    class: "row mx-0 mt-1 evaluated-questions"
};
const _hoisted_23 = { class: "table table-bordered table-striped table-sm me-3" };
const _hoisted_24 = { "data-cy": "evaluated-question" };
const _hoisted_25 = { "data-cy": "evaluated-question-response" };
const _hoisted_26 = { key: 0 };
const _hoisted_27 = {
    key: 0,
    class: "sub-name ps-1"
};
const _hoisted_28 = { class: "row mx-0 mt-3" };
const _hoisted_29 = { class: "row mx-0 mt-1" };
const _hoisted_30 = { class: "table table-bordered table-striped table-sm me-3" };
const _hoisted_31 = { "data-cy": "hospital-name" };
const _hoisted_32 = { "data-cy": "hospital-id" };
const _hoisted_33 = { "data-cy": "hospital-distance-in-meters" };
const _hoisted_34 = { "data-cy": "hospital-distance-in-minutes" };
const _hoisted_35 = { "data-cy": "hospital-certifications" };
const _hoisted_36 = {
    key: 4,
    class: "row mx-0 mt-3"
};
const _hoisted_37 = {
    key: 5,
    class: "row mx-0 mt-1"
};
const _hoisted_38 = { class: "table table-bordered table-striped table-sm me-3" };
const _hoisted_39 = { "data-cy": "constant-name" };
const _hoisted_40 = { "data-cy": "constant-value" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_GMapMarker = _resolveComponent("GMapMarker");
    const _component_GMapMap = _resolveComponent("GMapMap");
    return (_openBlock(), _createElementBlock("div", null, [
        ($setup.questionnaireResponseData)
            ? (_openBlock(), _createBlock($setup["BModal"], {
                key: 0,
                ref: "detailsModal",
                "no-footer": "",
                centered: "",
                scrollable: "",
                "modal-class": "questionnaire-response-details",
                size: "xl",
                title: _ctx.$t('JTADM_SHOW_RESPONSE_INFO')
            }, {
                default: _withCtx(() => [
                    _createVNode($setup["BContainer"], {
                        class: "mx-3",
                        fluid: ""
                    }, {
                        default: _withCtx(() => [
                            ($setup.questionnaireResponseData)
                                ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.$t('JTADM_QUESTIONNAIRE')) + " : " + _toDisplayString($setup.questionnaireResponseData.name_slug), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_2, [
                                ($setup.questionnaireResponseData)
                                    ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_ctx.$t('JTADM_BASIC_INFORMATION')), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    ($setup.questionnaireResponseData)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createElementVNode("table", _hoisted_7, [
                                                _cache[1] || (_cache[1] = _createElementVNode("thead", null, null, -1)),
                                                _createElementVNode("tbody", null, [
                                                    _createElementVNode("tr", _hoisted_8, [
                                                        _cache[0] || (_cache[0] = _createElementVNode("td", { class: "table-light" }, "UUID", -1)),
                                                        _createElementVNode("td", _hoisted_9, _toDisplayString($setup.questionnaireResponseData.full_uuid), 1)
                                                    ]),
                                                    _createElementVNode("tr", _hoisted_10, [
                                                        _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t('JTADM_VERSION')), 1),
                                                        _createElementVNode("td", _hoisted_12, _toDisplayString($setup.version), 1)
                                                    ]),
                                                    _createElementVNode("tr", _hoisted_13, [
                                                        _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.$t('JTADM_QUESTIONNAIRE')), 1),
                                                        _createElementVNode("td", _hoisted_15, _toDisplayString($setup.questionnaireResponseData.name_slug), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$t('JTADM_TIMESTAMP')), 1),
                                                        _createElementVNode("td", _hoisted_17, _toDisplayString($setup.questionnaireResponseData.created_at), 1)
                                                    ])
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('JTADM_RESPONSE_SCORE')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_19, [
                                        _createVNode($setup["Score"], {
                                            data: $setup.questionnaireResponseData.data
                                        }, null, 8, ["data"])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                    ($setup.marker)
                                        ? (_openBlock(), _createBlock(_component_GMapMap, _mergeProps({
                                            key: 0,
                                            class: "gmap-modal questionnaire-response-details-map"
                                        }, $setup.marker, {
                                            center: $setup.marker,
                                            zoom: 15
                                        }), {
                                            default: _withCtx(() => [
                                                _createVNode(_component_GMapMarker, {
                                                    icon: "fasted-marker.png",
                                                    position: $setup.marker,
                                                    animation: 2
                                                }, null, 8, ["position"])
                                            ]),
                                            _: 1
                                        }, 16, ["center"]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            ($setup.questions)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('JTADM_EVALUATED_QUESTIONS')), 1)
                                ]))
                                : _createCommentVNode("", true),
                            ($setup.questions)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createElementVNode("table", _hoisted_23, [
                                        _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('JTADM_QUESTIONS')), 1),
                                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('JTADM_RESPONSES')), 1)
                                            ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.questions, (question) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: question.id,
                                                    "data-cy": "evaluated-questions"
                                                }, [
                                                    _createElementVNode("td", _hoisted_24, _toDisplayString(question.text), 1),
                                                    _createElementVNode("td", _hoisted_25, [
                                                        (question.responses.length > 1)
                                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_26, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.responses, (subResponse) => {
                                                                    return (_openBlock(), _createElementBlock("li", {
                                                                        key: subResponse.text
                                                                    }, [
                                                                        _createTextVNode(_toDisplayString(subResponse.value), 1),
                                                                        (subResponse.text !== question.text)
                                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, "[" + _toDisplayString(subResponse.text) + "]", 1))
                                                                            : _createCommentVNode("", true)
                                                                    ]));
                                                                }), 128))
                                                            ]))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _createTextVNode(_toDisplayString(question.responses[0]?.value), 1)
                                                            ], 64))
                                                    ])
                                                ]));
                                            }), 128))
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            ($setup.questionnaireResponseData.hospital_objs?.length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('JTADM_HOSPITAL_PRIORITY')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("table", _hoisted_30, [
                                            _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('JTADM_NAME')), 1),
                                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('JTADM_ID')), 1),
                                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('JTADM_DISTANCE_METERS')), 1),
                                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('JTADM_DISTANCE_MINUTES')), 1),
                                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS')), 1)
                                                ])
                                            ]),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.questionnaireResponseData.hospital_objs, (hospital) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                        key: hospital.id,
                                                        "data-cy": "hospital-priority"
                                                    }, [
                                                        _createElementVNode("td", _hoisted_31, _toDisplayString(hospital.name), 1),
                                                        _createElementVNode("td", _hoisted_32, _toDisplayString(hospital.id), 1),
                                                        _createElementVNode("td", _hoisted_33, _toDisplayString(hospital.distance_in_meters), 1),
                                                        _createElementVNode("td", _hoisted_34, _toDisplayString($setup.secondsToMinutes(hospital.distance_in_seconds)), 1),
                                                        _createElementVNode("td", _hoisted_35, _toDisplayString(hospital.certifications.toString()), 1)
                                                    ]));
                                                }), 128))
                                            ])
                                        ])
                                    ])
                                ], 64))
                                : _createCommentVNode("", true),
                            ($setup.constants.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('JTADM_QUESTIONNAIRE_CONSTANTS')), 1)
                                ]))
                                : _createCommentVNode("", true),
                            ($setup.constants.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createElementVNode("table", _hoisted_38, [
                                        _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('JTADM_NAME')), 1),
                                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('JTADM_QUESTIONNAIRE_VALUE')), 1)
                                            ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.constants, (constant) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: constant.id,
                                                    "data-cy": "constants"
                                                }, [
                                                    _createElementVNode("td", _hoisted_39, _toDisplayString(constant.text), 1),
                                                    _createElementVNode("td", _hoisted_40, _toDisplayString(constant.value), 1)
                                                ]));
                                            }), 128))
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["title"]))
            : _createCommentVNode("", true)
    ]));
}
